<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="small" style="width: 200px;" class="filter-item"
          :placeholder="'名称'" v-model="listQuery.key"> </el-input>
        <el-button class="filter-item" size="small" v-waves icon="el-icon-search" @click="handleFilter">搜索</el-button>
        <permission-btn size="small" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white" style="height: 100%;">
        <auth-table style="height:calc(100% - 60px)" ref="mainTable" :select-type="'checkbox'"
          :table-fields="headerList" :data="list" v-loading="listLoading" @row-dblclick="onBtnClicked('btnEdit')"
          @row-click="rowClick" @selection-change="handleSelectionChange" :enable-sorting="true"
          :enable-custom-filter="true" @sort-change="handleSortChange" @filter-change="handleFilterChange"></auth-table>
        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
          @pagination="handleCurrentChange" />
      </div>
      <el-dialog v-el-drag-dialog class="dialog-mini" width="600px" :title="textMap[dialogStatus]"
        :visible.sync="dialogFormVisible">
        <el-row :gutter="10">
          <el-form ref="dataForm" :model="temp" :rules="rules" size="medium" label-width="100px" label-position="left">
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="姓名" prop="name">
                    <el-input v-model="temp.name" placeholder="请输入姓名" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="手机号" prop="phoneNumber">
                    <el-input v-model="temp.phoneNumber" placeholder="请输入手机号" maxlength="11" :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="邮箱" prop="mail">
                    <el-input v-model="temp.mail" placeholder="请输入邮箱" :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="单位名称" prop="tenantName">
                    <el-input v-model="temp.tenantName" placeholder="" readonly :style="{ width: '100%' }">
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="密码" prop="password">
                    <el-input v-model="temp.password" placeholder="请输入密码" show-password
                      :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="角色" prop="roleName">
                    <el-select v-model="temp.roleName" placeholder="请选择角色" @change="handleRoleChange"
                      :style="{ width: '100%' }" :disabled="dialogStatus === 'update' && !isAdmin">
                      <el-option v-for="item in roleOptions" :key="item.id" :label="item.name"
                        :value="item.name"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="部门" prop="dep">
                    <el-input v-model="temp.dep" placeholder="请输入部门" :style="{ width: '100%' }"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-form>
        </el-row>
        <div slot="footer">
          <el-button size="small" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="small" v-if="dialogStatus == 'create'" type="primary" @click="createData">确认</el-button>
          <el-button size="small" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import * as tenantUsers from '@/api/basic/tenantUsers'
import waves from '@/directive/waves' // 水波纹指令
import Sticky from '@/components/Sticky'
import permissionBtn from '@/components/PermissionBtn'
import Pagination from '@/components/Pagination'
import elDragDialog from '@/directive/el-dragDialog'
import { defaultVal } from '@/utils/index'
import extend from '@/extensions/common.js'
import AuthTable from '../../../components/Base/AuthTable.vue'
import ColumnDefine from '@/interface/columnDefine'

export default {
  name: 'tenantUser',
  components: { Sticky, permissionBtn, Pagination, AuthTable, },
  directives: {
    waves,
    elDragDialog,
  },
  mixins: [extend],
  data() {
    return {
      headerList: [], // 主列表列定义
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      filteredList: null, // 过滤后的列表数据
      total: 0,
      listLoading: true,
      listQuery: {
        // 查询条件
        page: 1,
        limit: 100,
        key: undefined,
      },
      roleOptions: [], // 角色选项列表
      temp: {
        phoneNumber: '',
        name: '',
        tenantName: '',
        password: '',
        tenantId: '',
        roleName: '',
        roleId: '',
        mail: '',
        dep: ''
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      isAdmin: false, // 添加判断是否为管理员的标志
      adminRoleId: '09ee2ffa-7463-4938-ae0b-1cb4e80c7c13', // 管理员角色ID
      rules: {
        name: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        phoneNumber: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }, {
          pattern: /^1[3-9]\d{9}$/,
          message: '请输入正确的手机号格式',
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '未填写',
          trigger: 'blur'
        }],
        roleName: [{
          required: true,
          message: '请选择角色',
          trigger: 'change'
        }]
      },
    }
  },
  created() {
    this.headerList = [

      new ColumnDefine('name', '姓名', true, true, '', '', 'string', 'varchar', 'Name', '120px'),
      new ColumnDefine('phoneNumber', '手机号', true, true, '', '', 'int', 'int', 'PhoneNumber', '120px'),
      new ColumnDefine('tenantName', '单位名称', true, true, '', '', 'string', 'varchar', 'TenantName', '150px'),
      new ColumnDefine('roleName', '角色', true, true, '', '', 'string', 'varchar', 'RoleName', '120px'),
      // new ColumnDefine('dep', '部门', true, true, '', '', 'string', 'varchar', 'Dep'),
      // new ColumnDefine('post', '岗位', true, true, '', '', 'string', 'varchar', 'Post'),
    ]
    this.getList()
    this.getRoleOptions()
    this.checkUserRole() // 检查当前用户角色
  },
  methods: {
    // 检查当前用户是否为管理员
    async checkUserRole() {
      try {
        var response = await tenantUsers.getCurrentUserRole()
        console.log('获取用户角色响应:', response)

        if (response && response.result) {
          // 处理返回的是角色数组的情况
          if (Array.isArray(response.result)) {
            // 在数组中查找是否有管理员角色ID
            this.isAdmin = response.result.some(role => role.id === this.adminRoleId)

          } else if (response.result.roleId) {
            this.isAdmin = response.result.roleId === this.adminRoleId
          } else if (response.result.id) {
            // 如果直接返回角色对象
            this.isAdmin = response.result.id === this.adminRoleId
          } else {
            this.isAdmin = false
          }
        } else {
          this.isAdmin = false
        }
      } catch (error) {
        console.error('获取用户角色信息失败:', error)
        this.isAdmin = false
      }
    },
    // 获取角色选项列表
    async getRoleOptions() {
      try {
        const res = await tenantUsers.getRoles();
        if (res && res.result) {
          this.roleOptions = res.result;
        } else {
          console.error('获取角色列表失败', res);
        }
      } catch (error) {
        console.error('获取角色列表出错:', error);
        this.$message.error('获取角色信息失败');
      }
    },
    // 角色选择变更处理
    handleRoleChange(value) {
      // 根据选中的角色名找到对应的角色ID
      const selectedRole = this.roleOptions.find(role => role.name === value);
      if (selectedRole) {
        this.temp.roleId = selectedRole.id;
      } else {
        this.temp.roleId = '';
      }
    },
    async getTenantOptions() {
      try {
        // 获取租户ID
        const tenantId = localStorage.getItem('tenantId');
        console.log('tenantId:', tenantId);
        if (!tenantId) {
          console.error('未获取到租户ID');
          return;
        }
        // 获取单位列表
        const res = await tenantUsers.getTenantList(tenantId);
        if (res && res.result) {
          this.temp.tenantName = res.result[0].tenantName;
          this.temp.tenantId = res.result[0].tenantCode;

        } else {
          console.error('获取单位列表失败', res);
        }
      } catch (error) {
        console.error('获取单位列表出错:', error);
        this.$message.error('获取单位信息失败');
      }

    },
    rowClick(row) {
      this.$refs.mainTable.clearSelection()
      this.$refs.mainTable.toggleRowSelection(row)
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onBtnClicked: function (domId, callback) {
      console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate()
          break
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error',
            })
            return
          }
          this.handleUpdate(this.multipleSelection[0])
          break
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error',
            })
            return
          }
          this.handleDelete(this.multipleSelection)
          break
        case 'btnExport':
          this.$refs.mainTable.exportExcel('资源文件', callback)
          break
        default:
          break
      }
    },
    getList() {
      this.listLoading = true
      tenantUsers.getList(this.listQuery).then((response) => {
        this.list = response.data
        this.total = response.count
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page
      this.listQuery.limit = val.limit
      this.getList()
    },
    handleModifyStatus(row, disable) {
      // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success',
      })
      row.disable = disable
    },
    resetTemp() {
      let obj = {};
      this.headerList.forEach((item) => {
        obj[item.columnName] = defaultVal(item.entityType)
      })
      this.temp = Object.assign({}, obj) // copy obj
    },
    handleCreate() {
      // 弹出添加框
      this.resetTemp()
      this.getTenantOptions() // 获取单位信息
      this.dialogStatus = 'create'

      this.dialogFormVisible = true

      this.$nextTick(() => {
        // 添加模式下，启用所有字段
        setTimeout(() => {
          const formItems = this.$refs['dataForm'].$el.querySelectorAll('.el-form-item')
          formItems.forEach(item => {
            const input = item.querySelector('input, .el-select')
            if (input && input.hasAttribute('disabled')) {
              input.removeAttribute('disabled')
            }
          })
        }, 0)
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      const loadingInstance = this.$loading({
        lock: true,
        text: '数据提交中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          loadingInstance.close();
          return;
        }
        tenantUsers.add(this.temp).then(() => {
          loadingInstance.close();
          this.list.unshift(this.temp);
          this.dialogFormVisible = false;
          this.$notify({
            title: '成功',
            message: '创建成功',
            type: 'success',
            duration: 2000,
          });
          this.getList();
        }).catch(error => {
          loadingInstance.close();
          console.error('创建失败:', error);
          this.$notify({
            title: '错误',
            message: '创建失败',
            type: 'error',
            duration: 2000,
          });
        });
      });
    },
    handleUpdate(row) {
      // 弹出编辑框
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        // 如果不是管理员，只允许修改密码
        if (!this.isAdmin) {
          // 动态设置表单项的禁用状态
          this.$refs['dataForm'].clearValidate()
          // 设置只有密码字段可编辑
          setTimeout(() => {
            const formItems = this.$refs['dataForm'].$el.querySelectorAll('.el-form-item')
            formItems.forEach(item => {
              const label = item.querySelector('.el-form-item__label').textContent.trim()
              if (label !== '密码') {
                const input = item.querySelector('input, .el-select')
                if (input) {
                  input.setAttribute('disabled', 'disabled')
                }
              }
            })
          }, 0)
        } else {
          this.$refs['dataForm'].clearValidate()
        }
      })
    },
    updateData() {
      const loadingInstance = this.$loading({
        lock: true,
        text: '数据更新中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          loadingInstance.close();
          return;
        }
        const tempData = Object.assign({}, this.temp);

        // 如果不是管理员，只更新密码字段
        if (!this.isAdmin) {
          // 获取原始数据
          const originalData = this.list.find(item => item.id === tempData.id);
          if (originalData) {
            // 只保留密码字段的更新
            for (const key in tempData) {
              if (key !== 'password' && key !== 'id') {
                tempData[key] = originalData[key];
              }
            }
          }
        }

        tenantUsers.update(tempData).then(() => {
          loadingInstance.close();
          for (const v of this.list) {
            if (v.id === this.temp.id) {
              const index = this.list.indexOf(v);
              this.list.splice(index, 1, this.temp);
              break;
            }
          }
          this.dialogFormVisible = false;
          this.$notify({
            title: '成功',
            message: '更新成功',
            type: 'success',
            duration: 2000,
          });
          this.getList();
        }).catch(error => {
          loadingInstance.close();
          console.error('更新失败:', error);
          this.$notify({
            title: '错误',
            message: '更新失败',
            type: 'error',
            duration: 2000,
          });
        });
      });
    },
    handleDelete(rows) {
      // 多行删除
      this.delrows(tenantUsers, rows)
    },

    // 处理表格排序
    handleSortChange({ prop, order }) {
      if (!prop || !order) return;

      const data = this.filteredList || this.list;
      const sortedData = [...data];

      sortedData.sort((a, b) => {
        let valueA = a[prop];
        let valueB = b[prop];

        // 处理数字类型
        if (!isNaN(Number(valueA)) && !isNaN(Number(valueB))) {
          valueA = Number(valueA);
          valueB = Number(valueB);
        }

        // 处理日期类型
        if (valueA && valueB && !isNaN(Date.parse(valueA)) && !isNaN(Date.parse(valueB))) {
          valueA = new Date(valueA);
          valueB = new Date(valueB);
        }

        // 按照顺序排序
        if (order === 'ascending') {
          return valueA > valueB ? 1 : -1;
        } else {
          return valueA < valueB ? 1 : -1;
        }
      });

      this.list = sortedData;
    },

    // 处理表格筛选
    handleFilterChange(filteredData) {
      this.filteredList = filteredData;
      this.list = filteredData;
      this.total = filteredData.length;
    },
  },
}
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
